module.exports = __webpack_public_path__ + "static/media/3.17effd2d.JPG";